const steps = {
    INITIAL: 'INITIAL',
    SAVING: 'SAVING',
    SAVED: 'SAVED',
};

class CartSaveListController {
    constructor($timeout, $rootScope, $sanitize, moveFocus, sessionStorage, trolleyService, shopperService, loginService, shopPageStateService, savedListsService) {
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$sanitize = $sanitize;

        this.moveFocus = moveFocus;
        this.sessionStorage = sessionStorage;
        this.trolleyService = trolleyService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.shopPageStateService = shopPageStateService;
        this.savedListsService = savedListsService;

        this.steps = steps;
    }

    $onInit() {
        this.step = this.steps.INITIAL;
        this.saving = false;

        this.pendingSaveAsListStorageKey = 'CartSaveListController:pendingSaveAsList';

        if (!this.shopperService.IsGuest) {
            this.savePendingList(this.sessionStorage.getJsonAndRemove(this.pendingSaveAsListStorageKey));
        }
    }

    savePendingList(listName) {
        if (!listName) return;

        this.newListName = listName;
        this.step = this.steps.SAVING;
        this.shopPageStateService.isCartOpen = true;

        // Waiting for cart to open and the step to change
        this.$timeout(() => {
            this.saveForm.$setSubmitted();
            this.save(this.newListName);
        });
    }

    promptForLogin(listName) {
        return this.loginService.promptForLogin('Please login to save your trolley as a list.', undefined, undefined, { reload: false }, () => {
            this.sessionStorage.setJson(this.pendingSaveAsListStorageKey, listName);
        });
    }

    save(listName) {
        listName = this.$sanitize(listName).trim();

        this.setServerErrors(null);
        this.saving = true;

        if (this.shopperService.IsGuest) {
            return this.promptForLogin(listName);
        }

        return this.trolleyService.saveTrolleyAsList(listName)
            .then(response => this.onSaved(response.plain()))
            .finally(() => (this.saving = false));
    }

    onSaved(response) {
        if (response.Success) {
            this.step = this.steps.SAVED;

            this.savedListsService.invalidate();
            this.$rootScope.$broadcast('saveTrolleyAsList:ListSuccessfull'); // TODO: refactor lists menu to update automatically without this
        } else {
            this.setServerErrors(response.Message);
        }
    }

    setServerErrors(message) {
        if (this.saveForm) {
            this.saveForm.newListName.$setValidity('server', !message);
        }

        this.serverErrorMessage = message;
    }

    clear() {
        this.newListName = '';
        this.setServerErrors(null);

        if (this.saveForm) {
            this.saveForm.$setPristine();
        }
    }

    reset() {
        this.clear();
        this.step = this.steps.INITIAL;

        this.moveFocus('._saveCartListInitial');
    }
}

const cartSaveListComponentDefinition = {
    controller: ['$timeout', '$rootScope', '$sanitize', 'MoveFocus', 'SessionStorageWrapper', 'TrolleyService', 'ShopperService', 'LoginService', 'ShopPageStateService', 'SavedListsService', CartSaveListController],
    template: require('./cart-save-list.component.html').trim(),
};

module.exports = {
    CartSaveListController,
    cartSaveListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-save-list.component.js